/**
 * Created by sl-c on 2018/03/25.
 * 常用方法
 */

/**
 * 判断数组是否有值
 * @param value
 * @returns {boolean}
 */
export function hasValue_arr(value) {
    if (value) {
        if (value.length > 0) {
            return true;
        }
    }
    return false;
}

/**
 * 将后台返回数据中的null || undefined转化成 ''
 * @param dataSource
 */
export function dealDataSource(dataSource) {
    for (let item of dataSource) {
        for (let key of Object.keys(item)) {
            // if (/(undefined|null)/g.test(item[key])) {
            if (item[key] === null) {
                item[key] = '';
            }
        }
    }
}


const methods = {
    'hasValue_arr': hasValue_arr,
    'dealDataSource': dealDataSource
};
export default methods;




// WEBPACK FOOTER //
// ./src/common.js